import { Http } from '@/lib/http';

export class DueDiligenceActionsService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/due-diligence-actions/';
  }

  createDueDiligenceActions(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  getDueDiligenceActions() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateDueDiligenceActions(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
}
